import { z } from 'zod';
import { UserSchema } from '../../entities/user/user.schema';
import { UserPermissionsSchema, AuthContextSchema } from '../../shared/authorization';
/**
 * Profile Response Schema
 * GET /api/v2/profile
 * Returns full user entity plus authorization data from backend
 */ export const ProfileResponseSchema = z.object({
    data: UserSchema,
    permissions: UserPermissionsSchema,
    authContext: AuthContextSchema,
    setupComplete: z.boolean(),
    seatOverrun: z.boolean()
});

//# sourceMappingURL=profile.schema.js.map